export default {
  'menu.welcome': 'Добро пожаловать',
  'menu.more-blocks': 'Больше блоков',
  'menu.home': 'Главная',
  'menu.console': 'Администратор',
  'menu.console.sub-page': 'Подстраница',
  'menu.login': 'Вход',
  'menu.register': 'Регистрация',
  'menu.register-result': 'Результат регистрации',
  'menu.dashboard': 'Панель управления',
  'menu.dashboard.analysis': 'Анализ',
  'menu.dashboard.monitor': 'Мониторинг',
  'menu.dashboard.workplace': 'Рабочее место',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Форма',
  'menu.form.basic-form': 'Базовая форма',
  'menu.form.step-form': 'Пошаговая форма',
  'menu.form.step-form.info': 'Пошаговая форма (ввод информации о переводе)',
  'menu.form.step-form.confirm': 'Пошаговая форма (подтверждение информации о переводе)',
  'menu.form.step-form.result': 'Пошаговая форма (завершено)',
  'menu.form.advanced-form': 'Расширенная форма',
  'menu.list': 'Список',
  'menu.list.table-list': 'Таблица поиска',
  'menu.list.basic-list': 'Базовый список',
  'menu.list.card-list': 'Список карточек',
  'menu.list.search-list': 'Список поиска',
  'menu.list.search-list.articles': 'Список поиска (статьи)',
  'menu.list.search-list.projects': 'Список поиска (проекты)',
  'menu.list.search-list.applications': 'Список поиска (приложения)',
  'menu.profile': 'Профиль',
  'menu.profile.basic': 'Базовый профиль',
  'menu.profile.advanced': 'Расширенный профиль',
  'menu.result': 'Результат',
  'menu.result.success': 'Успех',
  'menu.result.fail': 'Неудача',
  'menu.exception': 'Исключение',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Триггер',
  'menu.account': 'Аккаунт',
  'menu.account.center': 'Центр аккаунта',
  'menu.account.settings': 'Настройки аккаунта',
  'menu.account.trigger': 'Ошибка триггера',
  'menu.account.logout': 'Выход',
  'menu.account.profile': 'Профиль',
  'menu.console.agents': 'агенты',
  'menu.console.agentDevice': 'устройство агента',
  'menu.console.devices': 'устройства',
  'menu.console.speakers': 'Распознавание говорящего',
  'menu.console.voiceClone': 'Клонирование голоса',
  'menu.console.settings': 'Личные настройки',
  'menu.admin': 'Администратор',
  'menu.admin.dashboard': 'Панель управления',
  'menu.admin.settings': 'Настройки',
  'menu.admin.providers': 'Поставщики моделей',
  'menu.admin.unbindDevice': 'Отвязка устройства',
  'menu.admin.userManage': 'Управление пользователями',
  'menu.admin.systemConfig': 'Конфигурация системы',
  'menu.admin.whiteList': 'Белый список',
  'menu.admin.opsManage': 'Операции',
  'menu.admin.recorderManage': 'Управление записями',
  'menu.admin.deviceManage': 'Управление устройствами',

  'menu.console.agentSetting': 'Настройки агента',
};
